export default class DispatchWithUnwrapError<OriginalError = unknown> extends Error {
  public name = 'DispatchWithUnwrapError';
  public readonly responseStatus?: string | number;
  public readonly code?: string;
  public readonly stack?: string;
  public readonly requestDetails?: unknown;
  public readonly originalError: OriginalError;

  constructor(
    message: string,
    originalErrorName: string,
    cause: OriginalError,
    responseStatus?: string | number,
    code?: string,
    stack?: string,
    requestDetails?: unknown,
  ) {
    super(message);

    this.name = originalErrorName;
    this.cause = cause;
    this.originalError = cause;
    this.responseStatus = responseStatus;
    this.code = code;
    this.stack = stack;
    this.requestDetails = requestDetails;
  }
}
